import { ActionInterface } from "../../../Interface/ActionInterface";
import Constants from "../../../Action/Constants";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import Translator from "../../../Translation/Translator";

interface StateInterface {
  byId: any;
  allIds: string[];
};

const initialState: StateInterface = {
  byId: {},
  allIds: [],
};

export const unitsReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_UNIT_LIST_SUCCESS:
    {
      const byId = {};
      const units = [...action.payload?.units];

      units.forEach((unit: UnitInterface) => {
        byId[unit.id] = unit;
      });

      const allIds: string[] = Object.keys(byId);

      return {
        ...state,
        byId: {...byId},
        allIds: [...allIds],
      };
    }

    case Constants.GLOBAL_UNIT_CREATE_SUCCESS:
    {
      const byId = !!state.byId[action.payload?.unit.id] ? state.byId :
        {
          ...state.byId,
          [action.payload?.unit.id]: action.payload?.unit
        };

      const allIds: string[] = Object.keys(byId);

      return {
        ...state,
        byId: {...byId},
        allIds: [...allIds],
      };
    }


    case Constants.GLOBAL_UNIT_UPDATE_SUCCESS:
    case Constants.GLOBAL_UNIT_DELETE_SUCCESS:
    case Constants.GLOBAL_ATTACHMENT_UNIT_UPLOAD_SUCCESS:
    case Constants.GLOBAL_ATTACHMENT_UNIT_DELETE_SUCCESS:
    {
      const currentUnitsById = {...state.byId};
      delete currentUnitsById[action.payload?.unit.id];
      const byId = {
        [action.payload?.unit.id]: action.payload?.unit,
        ...currentUnitsById
      }

      const allIds: string[] = Object.keys(byId);
      return {
        ...state,
        byId: {...byId},
        allIds: [...allIds],
      };
    }

    case Constants.GLOBAL_SET_AVATAR_SUCCESS:
    {
      switch (action.payload?.entity.nameOfEntity.toLowerCase()) {
        case Translator.trans("unit").toLowerCase():
        {
          const currentUnitsById = {...state.byId};
          delete currentUnitsById[action.payload?.entity.id];
          const byId = {
            [action.payload?.entity.id]: action.payload?.entity,
            ...currentUnitsById
          }

          const allIds: string[] = Object.keys(byId);

          return {
            ...state,
            byId: {...byId},
            allIds: [...allIds],
          };
        }

        default:
          return {
            ...state
          };
      }
    }

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
